import React from 'react';
import { graphql } from 'gatsby';
import PageTemplate from '../components/PageTemplate';
import Cookie from '../components/shared/Cookie';

const Page = ({ data, location }) => {
  const {
    page,
    parent,
    children,
    wpFormsChildren,
    siblings,
    allWordpressWpNews: news,
    wordpressSiteMetadata: siteMeta,
    allJob: jobs,
    allDepartment: departments,
    // allInstaNode: instaPosts,
    allWordpressWpNewspost: newsposts,
    allWordpressWpOffice: offices,
    allWordpressWpPerson: employees,
  } = data;
  return (
    <>
      <PageTemplate
        page={page}
        parent={parent}
        children={children}
        wpFormsChildren={wpFormsChildren}
        siblings={siblings}
        offices={offices}
        news={news}
        employees={employees}
        jobs={jobs}
        departments={departments}
        siteMeta={siteMeta}
        // instaPosts={instaPosts}
        newsposts={newsposts}
      />
      <Cookie hidden={page.acf.disableCookieNotice} />
    </>
  );
};

export const pageQuery = graphql`
  query PageById($id: Int, $parent: Int) {
    page: wordpressPage(wordpress_id: { eq: $id }) {
      ...PageFragment
      acf {
        disableCookieNotice: disable_cookie_notice
      }
    }
    parent: wordpressPage(wordpress_id: { eq: $parent }) {
      wordpressId: wordpress_id
      path
      title
    }
    siblings: allWordpressPage(
      filter: { wordpress_parent: { eq: $parent } }
      sort: { fields: [menu_order], order: ASC }
    ) {
      edges {
        node {
          wordpressId: wordpress_id
          path
          title
        }
      }
    }
    children: allWordpressPage(
      filter: { wordpress_parent: { eq: $id } }
      sort: { fields: [menu_order], order: ASC }
    ) {
      edges {
        node {
          wordpressId: wordpress_id
          path
          title
        }
      }
    }
    wpFormsChildren: allWordpressPage(
      filter: { wordpress_parent: { eq: $id } }
      sort: { fields: [menu_order], order: ASC }
    ) {
      edges {
        node {
          path
          childrenWpForms: childWordPressAcfWpForms {
            page_heading
            page_subheading
            grid_frame_heading
            grid_icon {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1920, quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
          }
        }
      }
    }
    ...WordpressPageFragment
    ...WordpressSiteMetadataFragment
  }
`;

export default Page;
